import Mock from 'mockjs'

const Random = Mock.Random

let productList = [] //产品具体信息列表
let productStandardList = []
let applicatiomDoc = []
let selectGuide = []
let developResource = []
let skillData = []
let developTools = []
let otherArticle = []
let skillArticle = []
let wanBaoGangData = []
let jobList = []
let jobTableData = []
let getListTest = []
let size = [
  '300x250', '250x250', '240x400', '336x280',
  '180x150', '720x300', '468x60', '234x60',
  '88x31', '120x90', '120x60', '120x240',
  '125x125', '728x90', '160x600', '120x600',
  '300x600'
] // 定义随机值
for(let i = 0; i < 24; i ++) { // 可自定义生成的个数
  let template = {
    'chipLists': /[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][A-Z]/,
    'memoryLists|1': ['8k','16k','32k','64k'],
    'storageLists|1': ['256','512','768','1024'],
    'cpuhzLists|1': ['400K-16M','32K-12.3M','30K-16.6M','2M-12M'],
    'voltageLists|1': ['3.6-5.5','2.0-5.5','2.8-5.5'],
    'ioLists|1': ['14','26','30'],
    'breakSourceLists|1': ['3x16bits','4x16bits'],
    'timer|1': ['3x16bits','4x16bits'],
    'breakSourceLists1|1': ['3x16bits','4x16bits'],
  }

  productList.push(template)
}

Mock.mock('/api/getProductList', 'post', productList) // 根据数据模板生成模拟数据




for(let i = 0; i < 2; i ++) { // 可自定义生成的个数
  let template = {
    'name|1': ['SH79F166A规格书(中文版)','SH79F166A EVB使用说明书'],
    'description|1': ['-','-'],
    'update': Random.now(),
    'version|1': ['v2.2','v2.3'],
  }

  productStandardList.push(template)
}

Mock.mock('/api/getProductStandardList', 'post', productStandardList) // 根据数据模板生成模拟数据


for(let i = 0; i < 1; i ++) { // 可自定义生成的个数
let template = {
  'name': 'SH79F166A 应用说明',
  'description': '-',
  'update': Random.now(),
  'version|1': 'v2.2',
}

applicatiomDoc.push(template)
}

Mock.mock('/api/getApplicatiomDoc', 'post', applicatiomDoc) // 根据数据模板生成模拟数据



for(let i = 0; i < 1; i ++) { // 可自定义生成的个数
  let template = {
    'name': '中颖2018选型手册',
    'description': '-',
    'update': Random.now(),
    'version': 'v1.2',
  }

  selectGuide.push(template)
}

Mock.mock('/api/getSelectGuide', 'post', selectGuide) // 根据数据模板生成模拟数据



for(let i = 0; i < 5; i ++) { // 可自定义生成的个数
  let template = {
    'name|1': ['SH79F166A规格书(中文版)','JET51_Keil插件','Flash MCU开发工具及对应表','JETX1用户指南','PRO06固件'],
    'description|1': ['JET51使用说明以及安裝方法','Keil的插件，安装后使用JET51烧写器可实现keil环境下全部sinowealth 8051 mcu的下载以及仿真功能','JFlash MCU开发工具及对应表','JETX1使用说明以及安裝方法','PRO06固件，可以通过PRO06应用软件下载并且更新PR06量产烧写器的固件'],
    'update': Random.now(),
    'version|1': ['v1.2','v2.2'],
  }

  developResource.push(template)
}

Mock.mock('/api/getDevelopResource', 'post', developResource) // 根据数据模板生成模拟数据


for(let i = 0; i < 3; i ++) { // 可自定义生成的个数
  let template = {
    'name|1': ['SH69P25规格书(英文版)','SH69P25\\P23\\P20B EVB使用说明书','SH69P25 掩膜检查表'],
    'description|1': ['SH69P25','EVB','掩模检查表'],
    'version|1': ['v1.2','v2.2'],
    'update': Random.now(),
  }

  skillData.push(template)
}

Mock.mock('/api/getSkillData', 'post', skillData) // 根据数据模板生成模拟数据



for(let i = 0; i < 3; i ++) { // 可自定义生成的个数
  let template = {
    'name|1': ['SH69P25规格书(英文版)','SH69P25\\P23\\P20B EVB使用说明书','SH69P25规格书(英文版)'],
    'description|1': ['8 bit电话产品的仿真器的安装程式，适用于 Win98,Win2000, WinXP系统','-','可以通过keil安装目录下固件升级程序或者其他固件升级程序升级JET51的固件'],
    'version|1': ['v1.2','v2.2'],
    'update': Random.now(),
  }

  developTools.push(template)
}

Mock.mock('/api/getDevelopTools', 'post', developTools) // 根据数据模板生成模拟数据


for(let i = 0; i < 4; i ++) { // 可自定义生成的个数
  let template = {
    'title|1': ['ProWriter烧写器应用软件V3.2.4.8!','SH79F6442 Demo Code已经更新至V1.0!','SH79F6441 用户指南已经更新至V1.0!','SH79F6441 Demo Code已经更新至V1.0!'],
  }

  otherArticle.push(template)
}

Mock.mock('/api/getOtherArticle', 'post', otherArticle) // 根据数据模板生成模拟数据


for(let i = 0; i < 5; i ++) { // 可自定义生成的个数
  let template = {
    'title|1': ['JET51与JET51A差异说明', 'Pro06与Pro06A差异说明', 'ProWriter烧写器应用软件', '动力锂电池BMS简介', '动力锂电池BMS简介']
  }

  skillArticle.push(template)
}

Mock.mock('/api/getSkillArticle', 'post', skillArticle) // 根据数据模板生成模拟数据


for(let i = 0; i < 10; i ++) { // 可自定义生成的个数
  let template = {
    'type|1': ['规格书更新', 'DEMO CODE', '选型指南', '技术文章', '差异对照','EVB使用说明书','开发工具','掩膜检查表'],
    'content|1': ['更新ProWriter烧写器应用软件V3.2.4.8!','Flash Tools库文件已经更新至8.9!','JET51与JET51A差异说明',
                  '新增ProWriter烧写器应用软件V2.0!','基于中颖SH86313的迷你小音箱软件开发简介','JET51A固件已更新至V1.6!','掩膜选项及转Code工具已经更新至V1.4!'],
    'update|1': ['2018-09-09','2018-08-24','2018-07-18','2018-06-20'],
  }

  jobTableData.push(template)
}

Mock.mock('/api/getJobTableData', 'post', jobTableData) // 根据数据模板生成模拟数据



for(let i = 0; i < 1; i ++) { // 可自定义生成的个数
  let template = {
    'address': '7/F, No.586, Rui Guang Road, Nei-Hu District,Taipei 114,Taiwan, ROC.',
    'tel': '886-2-2657 9336',
    'fax': '886-2-2657 8030',
    'email': 'tw@mobicon.com',
    'contact': 'Ms Ann.',
    'websitel': 'www.mobicon.com.tw',
  }

  wanBaoGangData.push(template)
}

Mock.mock('/api/getWanBaoGangData', 'post', wanBaoGangData) // 根据数据模板生成模拟数据


for(let i = 0; i < 3; i ++) { // 可自定义生成的个数
  let template = {
    'jobName|1': ['锂电池管理与保护应用工程师','锂电池容量计算法工程师'],
    'jobPlace|1': ['上海、深圳、西安','上海'],
    'peopleNum|1': ['1','2'],
    'updateTime|1': Random.now(),
  }

  jobList.push(template)
}

Mock.mock('/api/getJobList', 'post', jobList) // 根据数据模板生成模拟数据



for(let i = 0; i < 8  ; i ++) { // 可自定义生成的个数
  let template = {
    'chipLists|1': ['SH69P25-SH69P21-SH69P20C','SH69P21-SH69K20A','SH69P20C-SH66K33A-SH66K33A','SH66K33A','SH69K20A-SH66K33A','SH66K33A-SH66K33A'],
    'memoryLists|1': ['8k','16k','32k','64k'],
    'storageLists|1': ['256','512','768','1024'],
    'cpuhzLists|1': ['400K-16M','32K-12.3M','30K-16.6M','2M-12M'],
    'voltageLists|1': ['3.6-5.5','2.0-5.5','2.8-5.5'],
    'ioLists|1': ['14','26','30'],
    'breakSourceLists|1': ['3x16bits','4x16bits'],
    'timer|1': ['3x16bits','4x16bits'],
    'breakSourceLists1|1': ['3x16bits','4x16bits'],
  }
  getListTest.push(template)
}

Mock.mock(/\/api\/getListTest[\s\S]*?/, 'get' ,getListTest


//   (options)=>{
//   console.log("this.options----->",options)
//   let url = options.url;
//   let theRequest = new Object();
//   if(url.indexOf("?") != -1){
//     let str = url.substr(1);
//     let strs = str.split("&");
//     console.log("this.strs---->",);
//     for(let i = 0;i<strs.length;i++){
//       theRequest[strs[i].split("=")[0]=unescape(strs[i].split("=")[1])];
//     }
//     console.log("this.data----->",theRequest);
//   }
//   console.log("this.url----->",options.url);
// }
) // 根据数据模板生成模拟数据





// WEBPACK FOOTER //
// ./src/mock.js